import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import z from "zod/v4";
import { EnvironmentService } from "../../core/services/environment.service";
import { RSVPSubmission, RSVPSubmissionSchema } from "./rsvp.model";
import { PolterabendRSVP, PolterabendRSVPSchema } from "./models/polterabend-rsvp.model";

@Injectable({
    providedIn: 'root'
})
export class ResponseService {
    private http = inject(HttpClient);
    private env = inject(EnvironmentService);

    submitRSVP(rsvp: RSVPSubmission): Observable<unknown> {
        // Zod validation before API call
        try {
            const validatedData = RSVPSubmissionSchema.parse(rsvp);
            return this.http.post(this.env.getApiEndpoint('rsvp'), validatedData);
        } catch (error) {
            if (error instanceof z.ZodError) {
                return throwError(() => ({
                    message: 'Validierungsfehler',
                    errors: error.issues
                }));
            }
            return throwError(() => error);
        }
    }

    submitPolterabendRSVP(rsvp: PolterabendRSVP): Observable<unknown> {
        // Zod validation before API call
        try {
            const validatedData = PolterabendRSVPSchema.parse(rsvp);
            return this.http.post(this.env.getApiEndpoint('rsvp/polterabend'), validatedData);
        } catch (error) {
            if (error instanceof z.ZodError) {
                return throwError(() => ({
                    message: 'Polterabend Validierungsfehler',
                    errors: error.issues
                }));
            }
            return throwError(() => error);
        }
    }
}
